import { render, staticRenderFns } from "./SlaveView.vue?vue&type=template&id=c58871de&"
import script from "./SlaveView.vue?vue&type=script&lang=js&"
export * from "./SlaveView.vue?vue&type=script&lang=js&"
import style0 from "./SlaveView.vue?vue&type=style&index=0&id=c58871de&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports